export enum ClaimShipmentStatusEnum {
    SENT = "0",
    NOT_SENT = "1",
    UNABLE_TO_BE_SENT = "2"
};